(function () {
  if (window.wafarDeliverySlots) return;
  window.wafarDeliverySlots = true;

  var TZ = 'Asia/Kuwait';
  var LEAD = 10;
  var FIRST = 600;
  var STEP = 120;
  var COUNT = 7;
  var KEY_DATE = 'تاريخ التوصيل';
  var KEY_SLOT = 'فترة التوصيل';
  var NOTE_DATE = 'Delivery Date:';
  var NOTE_SLOT = 'Delivery Time:';
  var OLD_PREFIXES = ['تاريخ التوصيل /', 'فترة التوصيل /'];
  var NL = String.fromCharCode(10);
  var WD_AR = ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
  var WD_EN = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MO_AR = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
  var MO_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var TXT = {
    ar: {
      title: 'موعد التوصيل',
      step1: '1. اختر اليوم',
      step2: '2. اختر فترة التوصيل',
      picked: 'الموعد المختار: ',
      today: 'اليوم',
      tomorrow: 'غدًا',
      friday: 'الجمعة: فترة الظهيرة تبدأ 1:00 م بسبب وقت الصلاة',
      error: 'اختر موعد التوصيل لإتمام الطلب'
    },
    en: {
      title: 'Choose delivery time',
      step1: '1. Day',
      step2: '2. Time window',
      picked: 'Selected: ',
      today: 'Today',
      tomorrow: 'Tomorrow',
      friday: 'Friday: the noon slot starts at 1:00 PM due to prayer time',
      error: 'Choose a delivery time to continue'
    }
  };
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  var state = null;
  var uiDay = null;
  var errShow = false;
  var pending = null;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function nowKw() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h23'
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) {
      o[p.type] = parseInt(p.value, 10);
    });
    return { y: o.year, m: o.month, d: o.day, min: (o.hour % 24) * 60 + o.minute };
  }

  function addDays(base, n) {
    var dt = new Date(Date.UTC(base.y, base.m - 1, base.d + n));
    return { y: dt.getUTCFullYear(), m: dt.getUTCMonth() + 1, d: dt.getUTCDate(), w: dt.getUTCDay() };
  }

  function keyOf(o) {
    return o.y * 10000 + o.m * 100 + o.d;
  }

  function fmt(m, ar) {
    var h = Math.floor(m / 60);
    var mm = m % 60;
    var h12 = h % 12 === 0 ? 12 : h % 12;
    var suffix = ar ? (h >= 12 ? 'م' : 'ص') : (h >= 12 ? 'PM' : 'AM');
    return h12 + ':' + (mm < 10 ? '0' : '') + mm + ' ' + suffix;
  }

  function slotLabel(s, ar) {
    return fmt(s.s, ar) + ' - ' + fmt(s.e, ar);
  }

  function slotsFor(w) {
    var out = [];
    for (var i = 0; i < COUNT; i++) {
      var s = FIRST + i * STEP;
      var e = s + STEP - 1;
      if (w === 5 && i === 1) s = 780;
      out.push({ id: i, s: s, e: e, avail: true });
    }
    return out;
  }

  function days() {
    var n = nowKw();
    var t0 = addDays(n, 0);
    var t1 = addDays(n, 1);
    var s0 = slotsFor(t0.w);
    var any = false;
    s0.forEach(function (s) {
      s.avail = s.s >= n.min + LEAD;
      if (s.avail) any = true;
    });
    var list = [];
    if (any) list.push({ idx: 0, info: t0, slots: s0 });
    list.push({ idx: 1, info: t1, slots: slotsFor(t1.w) });
    return list;
  }

  function dayLabel(info, ar) {
    return info.d + ' ' + (ar ? MO_AR : MO_EN)[info.m - 1];
  }

  function dateValue(info) {
    return WD_AR[info.w] + ' ' + info.d + '/' + info.m + '/' + info.y;
  }

  function entry(idx) {
    var list = days();
    for (var i = 0; i < list.length; i++) {
      if (list[i].idx === idx) return list[i];
    }
    return null;
  }

  function isValid(sel) {
    if (!sel) return false;
    var e = entry(sel.day);
    if (!e) return false;
    for (var i = 0; i < e.slots.length; i++) {
      if (e.slots[i].id === sel.slot) return e.slots[i].avail;
    }
    return false;
  }

  function parseSaved(dateStr, slotStr) {
    if (!dateStr || !slotStr) return null;
    var m = /(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(dateStr);
    if (!m) return null;
    var key = parseInt(m[3], 10) * 10000 + parseInt(m[2], 10) * 100 + parseInt(m[1], 10);
    var list = days();
    for (var i = 0; i < list.length; i++) {
      if (keyOf(list[i].info) !== key) continue;
      for (var j = 0; j < list[i].slots.length; j++) {
        var s = list[i].slots[j];
        if (s.avail && slotLabel(s, true) === slotStr) return { day: list[i].idx, slot: s.id };
      }
    }
    return null;
  }

  function slotOf(e, id) {
    var slot = null;
    e.slots.forEach(function (s) {
      if (s.id === id) slot = s;
    });
    return slot;
  }

  function noteBlock(sel) {
    if (!sel) return '';
    var e = entry(sel.day);
    if (!e) return '';
    var slot = slotOf(e, sel.slot);
    if (!slot) return '';
    var i = e.info;
    return NOTE_DATE + ' ' + WD_EN[i.w] + ' ' + i.d + '/' + i.m + '/' + i.y + ' | ' + NOTE_SLOT + ' ' + slotLabel(slot, false);
  }

  function isOurLine(t) {
    if (t.indexOf(NOTE_DATE) === 0 || t.indexOf(NOTE_SLOT) === 0) return true;
    for (var k = 0; k < OLD_PREFIXES.length; k++) {
      if (t.indexOf(OLD_PREFIXES[k]) === 0) return true;
    }
    return false;
  }

  function stripNote(note) {
    return String(note || '').split(NL).filter(function (ln) {
      return !isOurLine(ln.trim());
    }).join(NL).trim();
  }

  function save(sel) {
    var attrs = {};
    if (sel) {
      var e = entry(sel.day);
      var slot = slotOf(e, sel.slot);
      attrs[KEY_DATE] = dateValue(e.info);
      attrs[KEY_SLOT] = slotLabel(slot, true);
    } else {
      attrs[KEY_DATE] = '';
      attrs[KEY_SLOT] = '';
    }
    var block = noteBlock(sel);
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return { note: '' };
      })
      .then(function (cart) {
        var base = stripNote(cart && cart.note);
        var note = block ? (base ? base + NL : '') + block : base;
        return fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attrs, note: note })
        });
      });
  }

  function ensureNote(sel) {
    var block = noteBlock(sel);
    if (!block) return;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (String((cart && cart.note) || '').indexOf(block) === -1 && !pending) track(save(sel));
      })
      .catch(function () {});
  }

  function track(p) {
    var wrapped = p
      .catch(function () {})
      .then(function () {
        if (pending === wrapped) pending = null;
      });
    pending = wrapped;
  }

  function pickedText(ar, t) {
    if (!state) return '';
    var e = entry(state.day);
    if (!e) return '';
    var out = '';
    e.slots.forEach(function (s) {
      if (s.id === state.slot && s.avail) {
        out = (e.idx === 0 ? t.today : t.tomorrow) + ' ' + dayLabel(e.info, ar) + ' - ' + slotLabel(s, ar);
      }
    });
    return out;
  }

  function render(el) {
    var ar = el.getAttribute('data-lang') === 'ar';
    var t = ar ? TXT.ar : TXT.en;
    var list = days();
    var cur = null;
    list.forEach(function (x) {
      if (x.idx === uiDay) cur = x;
    });
    if (!cur) {
      cur = list[0];
      uiDay = cur.idx;
    }
    var h = '<div class="wafar-slots__head">' + ICON_TRUCK + '<span>' + t.title + '</span></div>';
    h += '<div class="wafar-slots__body">';
    h += '<div class="wafar-slots__step">' + t.step1 + '</div>';
    h += '<div class="wafar-slots__days">';
    list.forEach(function (x) {
      var on = x.idx === uiDay ? ' is-on' : '';
      var tag = (x.idx === 0 ? t.today : t.tomorrow) + ' - ' + (ar ? WD_AR : WD_EN)[x.info.w];
      h += '<button type="button" class="wafar-slots__day' + on + '" data-day="' + x.idx + '"><span>' + dayLabel(x.info, ar) + '</span><small>' + tag + '</small></button>';
    });
    h += '</div>';
    h += '<div class="wafar-slots__step">' + t.step2 + '</div>';
    h += '<div class="wafar-slots__grid">';
    cur.slots.forEach(function (s) {
      var sel = state && state.day === cur.idx && state.slot === s.id;
      h += '<button type="button" class="wafar-slots__slot' + (sel ? ' is-on' : '') + '" data-slot="' + s.id + '"' + (s.avail ? '' : ' disabled') + '>' + (sel ? ICON_CHECK : '') + '<span>' + slotLabel(s, ar) + '</span></button>';
    });
    h += '</div>';
    var picked = pickedText(ar, t);
    if (picked) h += '<div class="wafar-slots__picked">' + t.picked + picked + '</div>';
    if (cur.info.w === 5) h += '<p class="wafar-slots__note">' + t.friday + '</p>';
    h += '<p class="wafar-slots__err" role="alert"' + (errShow ? '' : ' hidden') + '>' + t.error + '</p>';
    h += '</div>';
    el.innerHTML = h;
  }

  function renderAll() {
    document.querySelectorAll('[data-wafar-slots]').forEach(render);
  }

  function initNew() {
    var fresh = [];
    document.querySelectorAll('[data-wafar-slots]').forEach(function (el) {
      if (el.getAttribute('data-ready') === '1') return;
      el.setAttribute('data-ready', '1');
      fresh.push(el);
    });
    if (!fresh.length) return;
    var el = fresh[0];
    var dateStr = el.getAttribute('data-date');
    var saved = parseSaved(dateStr, el.getAttribute('data-slot'));
    if (saved) {
      state = saved;
      uiDay = saved.day;
      ensureNote(saved);
    } else {
      state = null;
      if (dateStr && !pending) track(save(null));
    }
    fresh.forEach(render);
  }

  function recheck() {
    if (state && !isValid(state)) {
      state = null;
      track(save(null));
    }
    renderAll();
  }

  function scrollToPicker() {
    var els = document.querySelectorAll('[data-wafar-slots]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].offsetParent !== null) {
        els[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var dayBtn = t.closest('.wafar-slots__day');
    if (dayBtn) {
      uiDay = parseInt(dayBtn.getAttribute('data-day'), 10);
      renderAll();
      return;
    }

    var slotBtn = t.closest('.wafar-slots__slot');
    if (slotBtn) {
      var sel = { day: uiDay, slot: parseInt(slotBtn.getAttribute('data-slot'), 10) };
      if (!isValid(sel)) {
        recheck();
        return;
      }
      state = sel;
      errShow = false;
      track(save(sel));
      renderAll();
      return;
    }

    var checkout = t.closest('#CartDrawer-Checkout, #checkout, [name="checkout"]');
    if (!checkout || !document.querySelector('[data-wafar-slots]')) return;

    if (pending) {
      e.preventDefault();
      e.stopImmediatePropagation();
      pending.then(function () {
        checkout.click();
      });
      return;
    }

    if (state && isValid(state)) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (state) state = null;
    errShow = true;
    renderAll();
    scrollToPicker();
  }, true);

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initNew();
    });
  });

  function start() {
    initNew();
    observer.observe(document.body, { childList: true, subtree: true });
    setInterval(recheck, 30000);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') recheck();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
